import React from "react";
import { motion } from "framer-motion";

export const SolutionsSection = () => {
  return (
    <section id="solutions" className="py-16 sm:py-20 lg:py-28 bg-gray-50" data-testid="solutions-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
        <div className="text-center mb-10 sm:mb-14">
          <span className="text-purple-600 font-semibold tracking-wider uppercase text-xs sm:text-sm">Our Services</span>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mt-2 sm:mt-3">
            Complete Painting <span className="text-purple-600">Solutions</span>
          </h2>
          <p className="text-gray-600 mt-3 max-w-xl mx-auto text-sm sm:text-base">
            From economy to luxury emulsions, we provide end-to-end painting services.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-4 sm:gap-6">
          <motion.div 
            initial={{ opacity: 0, y: 20 }} 
            whileInView={{ opacity: 1, y: 0 }} 
            viewport={{ once: true }} 
            className="rounded-2xl overflow-hidden shadow-lg bg-gradient-to-br from-purple-600 to-blue-600" 
            data-testid="solution-interior"
          >
            <div className="p-6 sm:p-8 text-white min-h-[280px] sm:min-h-[350px] flex flex-col justify-end">
              <h3 className="text-2xl sm:text-3xl font-bold mb-4 sm:mb-5">Interior Solutions</h3>
              <ul className="space-y-2 sm:space-y-3">
                <li className="flex items-center gap-2 sm:gap-3"><div className="w-1.5 h-1.5 sm:w-2 sm:h-2 bg-white rounded-full" /><span className="text-white/90 text-sm sm:text-base">Living Room Makeovers</span></li>
                <li className="flex items-center gap-2 sm:gap-3"><div className="w-1.5 h-1.5 sm:w-2 sm:h-2 bg-white rounded-full" /><span className="text-white/90 text-sm sm:text-base">Bedroom Transformations</span></li>
                <li className="flex items-center gap-2 sm:gap-3"><div className="w-1.5 h-1.5 sm:w-2 sm:h-2 bg-white rounded-full" /><span className="text-white/90 text-sm sm:text-base">Kitchen & Bath Finishes</span></li>
                <li className="flex items-center gap-2 sm:gap-3"><div className="w-1.5 h-1.5 sm:w-2 sm:h-2 bg-white rounded-full" /><span className="text-white/90 text-sm sm:text-base">Ceiling Designs</span></li>
              </ul>
            </div>
          </motion.div>

          <motion.div 
            initial={{ opacity: 0, y: 20 }} 
            whileInView={{ opacity: 1, y: 0 }} 
            viewport={{ once: true }} 
            transition={{ delay: 0.15 }} 
            className="rounded-2xl overflow-hidden shadow-lg bg-gradient-to-br from-orange-500 to-red-500" 
            data-testid="solution-exterior"
          >
            <div className="p-6 sm:p-8 text-white min-h-[280px] sm:min-h-[350px] flex flex-col justify-end">
              <h3 className="text-2xl sm:text-3xl font-bold mb-4 sm:mb-5">Exterior Solutions</h3>
              <ul className="space-y-2 sm:space-y-3">
                <li className="flex items-center gap-2 sm:gap-3"><div className="w-1.5 h-1.5 sm:w-2 sm:h-2 bg-white rounded-full" /><span className="text-white/90 text-sm sm:text-base">Weather-Proof Coatings</span></li>
                <li className="flex items-center gap-2 sm:gap-3"><div className="w-1.5 h-1.5 sm:w-2 sm:h-2 bg-white rounded-full" /><span className="text-white/90 text-sm sm:text-base">Textured Exteriors</span></li>
                <li className="flex items-center gap-2 sm:gap-3"><div className="w-1.5 h-1.5 sm:w-2 sm:h-2 bg-white rounded-full" /><span className="text-white/90 text-sm sm:text-base">Anti-Fungal Paints</span></li>
                <li className="flex items-center gap-2 sm:gap-3"><div className="w-1.5 h-1.5 sm:w-2 sm:h-2 bg-white rounded-full" /><span className="text-white/90 text-sm sm:text-base">Waterproofing</span></li>
              </ul>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
